var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlassCheers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glass-cheers",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88612",
    "data-name": "Path 88612",
    d: "M39.922,32.2a1.667,1.667,0,0,0-2.086-1.1l-2.166.667L34.118,27.2A8.254,8.254,0,0,0,38,17.677L34.926,8.552A5.038,5.038,0,0,0,28.8,5.183l-6.419,1.79A4.943,4.943,0,0,0,20,8.462a4.943,4.943,0,0,0-2.38-1.49L11.2,5.183A5.013,5.013,0,0,0,5.087,8.5L1.976,17.76a8.259,8.259,0,0,0,3.94,9.469L4.342,31.775,2.167,31.1a1.668,1.668,0,1,0-1,3.183l3.6,1.118c.025,0,.04.028.065.038s.087.01.13.022L8.6,36.588a1.667,1.667,0,1,0,.99-3.183l-2.06-.642,1.558-4.5a8.3,8.3,0,0,0,.932.067A8.333,8.333,0,0,0,18,22.318l2-5.926,1.972,5.833a8.333,8.333,0,0,0,8.011,6.106,8.193,8.193,0,0,0,.968-.067l1.53,4.5-2.073.643a1.667,1.667,0,0,0,.99,3.183l3.625-1.125c.043-.012.088,0,.132-.022s.043-.032.07-.042l3.6-1.118a1.667,1.667,0,0,0,1.1-2.088ZM22.261,10.985a1.648,1.648,0,0,1,1.013-.8l6.418-1.788a1.667,1.667,0,0,1,.44-.062,1.7,1.7,0,0,1,1.62,1.232l1.268,3.768H22.482l-.358-1.062A1.667,1.667,0,0,1,22.261,10.985ZM9.863,8.332a1.678,1.678,0,0,1,.442.06l6.419,1.79a1.667,1.667,0,0,1,1.167,2.038l-.375,1.112H6.979L8.262,9.516a1.68,1.68,0,0,1,1.6-1.183Zm4.956,13a5,5,0,0,1-9.166,1.115,4.915,4.915,0,0,1-.487-3.706l.69-2.075H16.393Zm12.719,3.013a5.036,5.036,0,0,1-2.385-3.1l-1.548-4.581H34.143l.667,1.99a5,5,0,0,1-7.276,5.7Z",
    transform: "translate(0 3.334)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88613",
    "data-name": "Path 88613",
    d: "M15.921,6.5a1.667,1.667,0,0,0,2.245-.755l1.667-3.333A1.667,1.667,0,1,0,16.849.922L15.182,4.255A1.667,1.667,0,0,0,15.921,6.5Z",
    transform: "translate(10 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88614",
    "data-name": "Path 88614",
    d: "M7.839,5.745a1.671,1.671,0,0,0,2.991-1.49L9.163.922A1.667,1.667,0,1,0,6.18,2.412Z",
    transform: "translate(4.003 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88615",
    "data-name": "Path 88615",
    d: "M12.667,6.666A1.667,1.667,0,0,0,14.333,5V1.667a1.667,1.667,0,0,0-3.333,0V5A1.667,1.667,0,0,0,12.667,6.666Z",
    transform: "translate(7.333 0)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassCheers);
export default __webpack_public_path__ + "static/media/glass-cheers.6a649bef70af90e883eedac5f6232edf.svg";
export { ForwardRef as ReactComponent };